// Material UI
import { Typography } from "@mui/material";

export default function TFTAnalyticsSectionLabel() {
	return (
		<Typography className="!font-montserrat !font-medium !text-2xl/[1.2] text-default pt-8 pb-12" variant={"h3"}>
			Technician Flagged Time Analytics
		</Typography>
	);
}
